import {
    config,
    requestOptions,
    requestTypes,
    sendRequest,
} from "../../../Utilities/Api";

class ServerBraillerRepairDetailsApi {
    static getBraillerRepairRequestDetails(loanId: string, repairId: string | null = null) {
        if (loanId && loanId !== "00000000-0000-0000-0000-000000000000") {
            const queryParams = repairId ? `?repairId=${repairId}` : '';
            return sendRequest(
                requestOptions(
                    config.URL + `braillers/loans/${loanId}/repair-request-details${queryParams}`,
                    requestTypes.GET
                )
            );
        }
        
        if (repairId && repairId !== "00000000-0000-0000-0000-000000000000") {
            return sendRequest(
                requestOptions(
                    config.URL + `braillers/loans/repair/${repairId}/details`,
                    requestTypes.GET
                )
            );
        }

        return Promise.reject(new Error("Either loanId or repairId must be provided"));
    }
}

export const braillerRepairDetailsApi = config.environment.MODE === config.modes.SERVER 
    ? ServerBraillerRepairDetailsApi 
    : ServerBraillerRepairDetailsApi;
